import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";

export const inAppToWebDipSlice = createSlice({
	name: "in-app-to-web-dip",
	initialState,
	reducers: {
		setIsChecking: (state, action: PayloadAction<boolean>) => {
			state.isChecking = action.payload;
		}
	}
});

export const { setIsChecking } = inAppToWebDipSlice.actions;

export default inAppToWebDipSlice.reducer;
